/**
 * @module naming
 * @borrows string.camelCase as camelCase
 * @borrows string.kebabCase as kebabCase
 * @borrows string.pascalCase as pascalCase
 * @borrows string.snakeCase as snakeCase
 */

export { default as camelCase } from './camelCase';
export { default as kebabCase } from './kebabCase';
export { default as pascalCase } from './pascalCase';
export { default as snakeCase } from './snakeCase';
